/** @jsxImportSource theme-ui */
import { gql } from "@apollo/client";
import { Col, Container } from "@bottlebooks/gatsby-design-system";
import { FragmentType, graphql, useFragment } from "~/gql";
import { Fragment } from "react";
import ContentRow from "../ContentRow";
import ExhibitorContacts from "../ExhibitorPage/ExhibitorContacts.next";
import ProductDetailsSection from "./ProductDetailsSection.next";

export const fragment = graphql(`
  fragment ProductSections_RegisteredProduct on RegisteredProduct {
    productId
    registration {
      ...RegistrationContacts
    }
    product {
      ...ProductDetailsSection
    }
    # ...NoteableBanner
  }
`);

/**
 * A component to contain all the product details sections.
 * It can be used to prepend or append some content in shadowed components.
 * @param {object} props
 * @param {object} props.exhibitor The exhibitor.
 * @param {object} props.product The product.
 * @param {object} props.eventId The eventId.
 * @returns
 */
export default function ProductSections({
  data,
  eventId,
}: {
  data: FragmentType<typeof fragment>;
  eventId: string;
}) {
  const registeredProduct = useFragment(fragment, data);
  const registration = registeredProduct.registration;
  const product = registeredProduct.product;
  return (
    <Fragment>
      <Container sx={{ width: "100%" }}>
        <ContentRow>
          <Col flex>
            <ExhibitorContacts
              exhibitor={registration}
              eventId={eventId}
              sx={{ marginBottom: 3 }}
            />
          </Col>
        </ContentRow>
        <ContentRow>
          <ProductDetailsSection data={product} />
        </ContentRow>
      </Container>
      {/* <NoteableBanner product={product} /> */}
    </Fragment>
  );
}
